import { createAction, props } from '@ngrx/store';
import { ActionTypes } from './action-types';
import { AssignToMePayload } from '../assign-to-me.service';

export const assignToMeAction = createAction(
  ActionTypes.ASSIGN_TO_ME,
  props<{ payload: AssignToMePayload }>()
);

export const assignToMeSuccessAction = createAction(
  ActionTypes.ASSIGN_TO_ME_SUCCESS,
  props<{ data: any }>()
);

export const assignToMeFailureAction = createAction(
  ActionTypes.ASSIGN_TO_ME_FAILURE,
  props<{ error: any }>()
);
